<template>
  <div style="background: #FFFFFF;">
    <div class="video_top">
      <div class="vt">
        <div class="vt_logo"><a href="/"><img src="../assets/img/shiyan_logo2.png"/></a></div>
        <div v-if="!public" class="vt_nav">
          <a v-if="practice.length==0" class="vtn_wyks" href="javascript:"
            style="background:#C7C7C7"><span></span>{{ isCme ? '我要考试' : '我要练习' }}</a>
          <a v-else class="vtn_wyks" href="javascript:"
            @click="toPractice()"><span></span>{{ isCme ? '我要考试' : '我要练习' }}</a>
          <a v-if="handoutUrl==''" class="vtn_jy" href="javascript:" style="background:#C7C7C7"><span></span>讲　　义</a>
          <a v-else class="vtn_jy" href="javascript:" @click="openPDF()"><span></span>讲　　义</a>
          <a class="vtn_xxmb" href="javascript:" @click="objectiveVisible=true;plyrInstances[0].pause();"><span></span>学习目标</a>
          <a class="vtn_lsjj" href="javascript:" @click="teachInfoVisible=true;plyrInstances[0].pause();"><span></span>老师简介</a>
        </div>
      </div>
    </div>
    <!--视频播放-->
    <div v-loading="videoLoading" class="video_main" element-loading-text="正在初始化播放器...">
      <div class="vm">
        <!--视频模块-->
        <div class="vm_video">
          <video ref="video" controls crossorigin style="border-radius: 4px;"></video>
        </div>
        <!--视频目录-->
        <div class="vm_list">
          <div :title="courseName" class="vml_title">{{ courseName }}</div>
          <div class="vml_main">
            <ul>
              <li v-for="(item,index) in courseVideoArr" :class="{ vmlm_ing: defaultActive==(index+1) }"
                @click="handleSelect(index+1)">
                <span><img :src="item.posterUrl"/><p>{{ formatTime(item.videoTotalTime) }}</p></span>
                <a href="javascript:">
                  <!--<img v-if="palyerRecord && palyerRecord.indexOf(item.id)!=-1" src='../assets/img-4/over_ico.png' width='88' height='69' border='0' class='video_over' />-->
                  {{ item.name }}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="vm_star">
          <span class="vms_title">我要评分：</span>
          <div class="vms_pf">
            <el-tooltip placement="top">
              <div slot="content">
                {{ isUserRate ? '我的评星' : '单击提交评星' }}：
                <el-rate v-model="userRate" :disabled="isUserRate" :texts="['1分', '2分', '3分', '4分', '5分']"
                  show-text
                  text-color="#ff9900" @change="rateChange"></el-rate>
              </div>
              <el-rate v-model="rateValue" :texts="['1分', '2分', '3分', '4分', '5分']" disabled show-text
                text-color="#ff9900"></el-rate>
            </el-tooltip>
          </div>
          
          <div v-show="$route.query.p!='true' && $route.query.p!=true " class="video_dabiao">
            达标要求：{{ trainingInfo.electiveRatio }}% &nbsp;&nbsp;&nbsp;&nbsp; 目前已完成 ：{{ percent }}%
          </div>
          
          <div class="vm_qingxi">
            <el-tooltip placement="top">
              <div slot="content">
                标清:标准清晰度，适合网络条件好的情况，视频质量以及清晰度更高。
                <br/>
                普清:普通清晰度，如果标清播放卡顿可以尝试切换此模式，视频质量相对低，但是播放会更流畅。
              </div>
              <el-switch v-model="playModeValue"
                active-color="#13ce66"
                active-text="标清"
                allow-half
                inactive-color="#ff4949"
                inactive-text="普清"
                style="top:10px;float:right"
                @change="playModeChange">
              </el-switch>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
    <!--评论-->
    <comment :typeId="'1_'+$route.query.cId" class="video_comment"></comment>
    <footer1></footer1>
    
    <template>
      <el-dialog
        :visible.sync="teachInfoVisible"
        title="老师简介"
        width="50%">
        <div class="mt_main pl165 yh">
          <div class="mtm_left"><img :src="teachInfo.photo" height="185" width="150"/></div>
          <div class="mtm_right">
            <p>{{ teachInfo.nickName }}</p>
            <p>{{ teachInfo.about }}</p>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        :visible.sync="objectiveVisible"
        title="学习目标"
        width="50%">
        <div class="mt_main">
          <p>&nbsp;&nbsp;&nbsp;&nbsp;{{ objective }}</p>
        </div>
      </el-dialog>
      <loginLayer :visible.sync="loginVisible"></loginLayer>
    </template>
    
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :visible.sync="dialogVisible"
      size="tiny"
      title="练习">
      <span>{{ practiseData.stem }}</span><br/><br/>
      <el-radio-group v-model="practiseAns">
        <el-radio v-for="item in practiseData.opts" :key="item.id"
          :label="item.opt" style="display:block; white-space:nowrap;margin-left:0px">{{ item.opt + ' ' + item.ctnt }}
        </el-radio>
      </el-radio-group>
      <br/>
      <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="submitAnswer">确 定</el-button>
  </span>
    </el-dialog>
  </div>


</template>

<script>
import {
  getCourseWareByCourse,
  getTrainingById,
  getUserCoursePercent,
  postVideoCheckOnlineStudy,
  saveCourseRate,
  syncCourseStatus,
  trainingSignIn
} from '../api/api'
import comment from '../components/Comment'
import loginLayer from '../components/LoginLayer'
import footer1 from '../components/Footer1'
import plyr from 'plyr'
import 'plyr/dist/plyr.css'
import jsonp from 'jsonp'
import { mapGetters } from 'vuex'
import { VerifyDeviceBinding } from '../utils/fingerprint'

export default {
  components: {
    loginLayer,
    comment,
    footer1
  },
  data() {
    return {
      playModeValue: this.$storejs.get('playModeValue') == false ? false : true,
      plyrInstances: null,
      isCme: false,
      defaultActive: '1',
      courseName: '',
      courseVideoArr: [],
      objective: '',
      objectiveVisible: false,
      teachInfo: {},
      teachInfoVisible: false,
      handoutUrl: '',
      courseFieldID: '',
      practice: [],
      practiseSwitch: 0,
      dialogVisible: false,
      practiseData: {},
      practiseAns: '',
      watchTime: 0,
      watchTimeVideoLock: 0,
      codePause: false, //代码暂停
      public: !(this.$route.query.uId && this.$route.query.tId && this.$route.query.pId),
      palyerRecord: [],
      setT: null,
      setTLock: null,
      seekTime: 0,
      rateValue: 5,
      isUserRate: false,
      userRate: 0,
      loginVisible: false,
      videoLoading: true,
      trainingInfo: {},
      viewCourseTime: 0,
      courseCountTime: 0,
      percent: 0,
      studySignTimer: null, //学习签到定时器
      studySignInterval: 60 * 15, //弹出继续学习确认时间间隔
      studySignNum: 0 //学习签到倒计时
    }
  },
  watch: {
    watchTime: function (val, oldVal) {
      if (val == 40) {
        syncCourseStatus({//同步课程状态
          tId: this.$route.query.tId,
          pId: this.$route.query.pId,
          cId: this.$route.query.cId,
          upTime: this.watchTime
        }).then((response) => {
          if (!response.data) {
            this.$message.error('同步异常')
          } else {
            this.viewCourseTime += 40
            this.percent = parseInt(Math.floor(this.viewCourseTime / this.courseCountTime * 100)) > 100 ? 100 : parseInt(Math.floor(this.viewCourseTime / this.courseCountTime * 100))
          }
        })
        this.watchTime = 0
      }
    },
    //视频播放锁定计时保存
    watchTimeVideoLock: function (val) {
      if (val % 30 === 0) {
        this.postVideoCheckOnlineStudy(1)
        this.watchTimeVideoLock = 0
      }
    }
  },
  mounted() {
    this.plyrInstances = plyr.setup(this.$refs.video.dom, {
      // Output to console
      debug: false,
      blankUrl: 'https://source.yiboshi.com/plyr/blank.mp4'
    })
    this.initPlayerEvents()
    this.refreshPalyerRecord()
    
    getCourseWareByCourse({//获得课件
      userId: this.userInfo ? this.userInfo.id : '',
      trainingId: this.$route.query.tId,
      projId: this.$route.query.pId,
      courseId: this.$route.query.cId
    }).then((response) => {
      this.courseVideoArr = response.data.data.courseVideoArr
      this.courseName = response.data.data.courseName
      document.title = '课程播放-' + this.courseName
      this.objective = response.data.data.objective
      this.teachInfo = response.data.data.teachInfo || {}
      this.practiseSwitch = response.data.data.practiseSwitch
      this.handoutUrl = response.data.data.handoutInfo.url ? response.data.data.handoutInfo.url : ''
      this.courseFieldID = response.data.data.courseFieldID
      if (response.data.data.rateInfo.userRate) {
        this.rateValue = response.data.data.rateInfo.userRate
      }
      if (response.data.data.rateInfo.isUserRate) {
        this.isUserRate = response.data.data.rateInfo.isUserRate
        this.userRate = response.data.data.rateInfo.userRate
      }
      if (this.courseVideoArr && this.courseVideoArr.length > 0) {
        this.handleSelect(1, null)
      }
      this.videoLoading = false
      if (!this.public) {
        /*查询课后练习*/
        jsonp(process.env.EXAM_API_URL + 'course/practices/' + this.courseFieldID, (err, data) => {
          if (err) {
            return null
          } else {
            this.practice = data.data
          }
        })
      }
    })
    if (!this.public) {
      this.getUserCoursePercent()
      getTrainingById({//获得培训班信息
        id: this.$route.query.tId
      }).then((response) => {
        this.trainingInfo = response.data.data.training
        let {data} = response
        if (data.data.training.businessType === 102) {
          this.isCme = true
        }
        if (data.data.training.limitSingleDeviceLearning === 1) {
          VerifyDeviceBinding(this.userInfo.id, 60, this)
        }
        // 学习签到时长
        const signInIntervalTime = data.data.training.signInIntervalTime
        this.studySignInterval = (signInIntervalTime && signInIntervalTime * 60) || (15 * 60)
      })
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  methods: {
    /**
     * @description: 视频锁定(限制视频)
     */
    postVideoCheckOnlineStudy(operate) {
      if (this.trainingInfo.enableStudyOnTheSameTime || this.codePause) return
      postVideoCheckOnlineStudy({
        userId: this.$route.query.uId,
        trainingId: this.$route.query.tId,
        courseId: this.$route.query.cId,
        operate: operate,
        source: 'Web'
      }).then((res) => {
        if (res.data.code === -1) {
          this.$alert(
            '您正在其他浏览器播放学习本培训班课程，若要继续学习，请关闭或暂停其他课程。',
            '提示',
            {
              confirmButtonText: '确定',
              type: 'warning',
              showClose: false
            }
          )
          this.plyrInstances[0].pause()
          this.codePause = true
        }
      })
    },
    /**
     * @description: 学习签到
     */
    studySign(videoType) {
      if (!this.trainingInfo.enableSignIn) return
      if (videoType === 'playing') {
        const playbackRate = this.plyrInstances[0].getMedia().playbackRate || 1
        this.studySignTimer = setInterval(() => {
          //实时获取视频倍速参数,如有变化,重新创建计时器
          const realPlaybackRate = this.plyrInstances[0].getMedia().playbackRate || 1
          if (realPlaybackRate !== playbackRate) {
            clearInterval(this.studySignTimer)
            this.studySignTimer = null
            this.studySign('playing')
            return
          }
          if (this.studySignNum >= this.studySignInterval) {
            clearInterval(this.studySignTimer)
            this.plyrInstances[0].pause()
            this.studySignNum = 0
            this.studySignTimer = null
            if (this.plyrInstances[0].getMedia().scrollWidth > 860) {
              this.plyrInstances[0].toggleFullscreen()
            }
            this.$alert('确认继续学习吗?', '温馨提示', {
              confirmButtonText: '确定',
              showClose: false,
              callback: action => {
                this.trainingSignIn()
                this.plyrInstances[0].play()
              }
            })
          } else {
            this.studySignNum++
          }
        }, 1000 / playbackRate)
      } else if (videoType === 'pause') {
        clearInterval(this.studySignTimer)
        this.studySignTimer = null
      }
    },
    /**
     * @description: 学习签到记录
     */
    trainingSignIn() {
      const params = {
        userId: this.userInfo.id,
        trainingId: this.$route.query.tId,
        projId: this.$route.query.pId,
        courseId: this.$route.query.cId
      }
      trainingSignIn(params)
    },
    getUserCoursePercent() {
      getUserCoursePercent(this.userInfo.id, {//获得课程视频观看完成度
        trainingId: this.$route.query.tId,
        projectId: this.$route.query.pId,
        courseId: this.$route.query.cId
      }).then((response) => {
        this.viewCourseTime = response.data.viewCourseTime
        this.courseCountTime = response.data.courseCountTime
        this.percent = response.data.percent
      })
    },
    initPlayerEvents() {
      //开始播放
      this.plyrInstances[0].on('playing', (event) => {
        this.studySign('playing')
        if (!this.public && !this.setT) {
          this.setT = setInterval(() => {
            this.watchTime += 1
          }, 1000)
        }
        if (!this.public && !this.setTLock) {
          this.codePause = false
          this.setTLock = setInterval(() => {
            this.watchTimeVideoLock += 1
          }, 1000)
          this.postVideoCheckOnlineStudy(1)
        }
        if (this.seekTime != 0) {
          this.plyrInstances[0].seek(this.seekTime)
          this.seekTime = 0
        }
      })
      //暂停播放
      this.plyrInstances[0].on('pause', (event) => {
        this.studySign('pause')
        if (!this.public && this.setT) {
          this.setT = window.clearInterval(this.setT)
        }
        if (!this.public && this.setTLock) {
          this.postVideoCheckOnlineStudy(2)
          this.setTLock = window.clearInterval(this.setTLock)
        }
      })
      //媒体被清空（初始化）时触发
      this.plyrInstances[0].on('emptied', (event) => {
        if (!this.public && this.setT) {
          this.setT = window.clearInterval(this.setT)
        }
        if (!this.public && this.setTLock) {
          this.codePause = false
          this.postVideoCheckOnlineStudy(2)
          this.setTLock = window.clearInterval(this.setTLock)
        }
      })
      this.plyrInstances[0].on('ended', (event) => {
        if (!this.public) {
          if (this.setT) {
            this.setT = window.clearInterval(this.setT)
          }
          if (this.setTLock) {
            this.setTLock = window.clearInterval(this.setTLock)
          }
          if (this.palyerRecord.length > 0) {
            if (this.palyerRecord.indexOf(this.courseVideoArr[parseInt(this.defaultActive) - 1].id) == -1) {
              this.palyerRecord.push(this.courseVideoArr[parseInt(this.defaultActive) - 1].id)
              this.$storejs.set(this.$route.query.uId + '_' + this.$route.query.tId + '_' + this.$route.query.pId + '_' + this.$route.query.cId, this.palyerRecord)
            }
          } else {
            this.$storejs.set(this.$route.query.uId + '_' + this.$route.query.tId + '_' + this.$route.query.pId + '_' + this.$route.query.cId, [this.courseVideoArr[parseInt(this.defaultActive) - 1].id])
            this.refreshPalyerRecord()
          }
        }
        
        if (!this.public && this.practiseSwitch == 1) {
          jsonp(process.env.EXAM_API_URL + 'course/practices/' + this.courseFieldID + '?' +
            'chapter=' + this.defaultActive
            , (err, data) => {
              if (err) {
                return null
              } else {
                if (data.data[0]) {
                  this.dialogVisible = true
                  this.practiseData = data.data[0]
                } else {
                  this.switchNextPlayer()
                }
              }
            })
        } else {
          this.switchNextPlayer()
        }
      })
    },
    switchNextPlayer() {
      if (parseInt(this.defaultActive) + 1 <= this.courseVideoArr.length) {
        this.handleSelect((parseInt(this.defaultActive) + 1).toString())
        this.plyrInstances[0].play()
      } else {
        this.handleSelect('1')
      }
    },
    handleSelect(key, keyPath) {
      if (this.defaultActive != key) {
        this.defaultActive = key
      }
      this.plyrInstances[0].source({
        type: 'video',
        title: this.courseVideoArr[key - 1].name,
        sources: [{
          src: this.playModeValue ? this.courseVideoArr[key - 1].standardUrl : this.courseVideoArr[key - 1].ordinaryUrl,
          type: 'video/mp4'
        }
        ]
      })
      this.studySign('pause')
    },
    playModeChange(value) {
      this.playModeValue = value
      this.$storejs.set('playModeValue', value)
      this.seekTime = this.plyrInstances[0].getCurrentTime()
//        if (this.setT) {
//          window.clearInterval(this.setT);
//        }
      this.handleSelect(this.defaultActive)
      this.plyrInstances[0].play()
    },
    rateChange(value) {
      if (this.userInfo) {
        if (!this.isUserRate) {
          saveCourseRate({//用户提交课程评星
            courseId: this.$route.query.cId,
            userId: this.userInfo.id,
            rate: value
          }).then((response) => {
            let {data} = response
            if (data.status === 200) {
              this.$message.success(data.msg)
              this.isUserRate = true
              this.userRate = value
              this.rateValue = value
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      } else {
        this.userRate = 0
        this.loginVisible = true
      }
    },
    toPractice() {
      this.plyrInstances[0].pause()
      /*视频达标后才能考试*/
      if (this.percent >= this.trainingInfo.electiveRatio) {
        window.open('/usercenter/practice?courseId=' + this.$route.query.cId
          + '&courseFieldID=' + this.courseFieldID
          + '&trainingId=' + this.$route.query.tId
          + '&projectId=' + this.$route.query.pId
          + '&courseName=' + this.courseName
          + '&setTop=' + this.$route.query.setTop
          + '&parentPage=VideoPlayer', 'practiceOnly')
      } else {
        this.$alert('视频达到观看要求后方可进行考试', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          
          }
        })
      }
      
    },
    openPDF() {
      this.plyrInstances[0].pause()
      window.open('/handout'
        + '?uId=' + this.$route.query.uId
        + '&tId=' + this.$route.query.tId
        + '&pId=' + this.$route.query.pId
        + '&cId=' + this.$route.query.cId, 'handout_blank')
    },
    submitAnswer() {
      if (this.practiseAns) {
        if (this.practiseAns == this.practiseData.ans) {
          this.$message.success('选择正确，请继续学习课程！')
          this.dialogVisible = false
          this.switchNextPlayer()
        } else {
          this.$message.error('错了哦，请重新作答！')
        }
      } else {
        this.$message.error('请选择正确的选项！')
      }
    },
    refreshPalyerRecord() {
      let palyerRecord = this.$storejs.get(this.$route.query.uId + '_' + this.$route.query.tId + '_' + this.$route.query.pId + '_' + this.$route.query.cId)
      if (palyerRecord) {
        this.palyerRecord = palyerRecord
      }
    },
    formatTime(s) {
      let t = '00:00'
      if (s > -1) {
        t = ''
        let min = Math.floor(s / 60)
        if (min < 10) {
          t += '0'
        }
        t += min + ':'
        let sec = s % 60
        if (sec < 10) {
          t += '0'
        }
        t += sec
      }
      return t
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

body, div, dl, dt, dd, ul, ol, li, h1, h2, h3, h4, h5, h6, pre, code, form, legend, input, textarea, p, th, td {
  margin: 0;
  padding: 0;
}

.clear {
  font-size: 0;
  line-height: 0;
  display: block;
  clear: both;
  overflow: hidden;
  height: 0;
}

li {
  list-style: none;
}

h1, h2, h3, h4, h5, h6 {
  font-size: 100%;
}

a, a:link, a:visited {
  text-decoration: none;
  color: #333333;
}

a:hover {
  text-decoration: none;
  color: #FF5300;
}

body a img {
  border: 0;
}

body {
  font-size: 14px;
  color: #333333;
}

.video_top {
  width: 100%;
  min-width: 980px;
  height: 90px;
  background: #F5F5F5;
}

.vt {
  height: 90px;
  margin: 0 auto;
}

.vt_logo {
  float: left;
  width: 215px;
  margin-top: 24px;
}

.vt_logo a img {
  width: 215px;
}

.vt_nav {
  float: right;
  width: 801px;
  padding-top: 20px;
}

.vt_nav a {
  font-size: 18px;
  line-height: 50px;
  position: relative;
  display: block;
  float: right;
  width: 180px;
  height: 50px;
  margin-left: 20px;
  padding-left: 50px;
  text-align: center;
  color: #FFFFFF;
  border-radius: 6px;
}

.vt_nav a span {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 50px;
  height: 50px;
  -moz-transition: background .2s ease;
  -o-transition: background .2s ease;
  -webkit-transition: background .2s ease;
  transition: background .2s ease;
  border-radius: 6px 0 0 6px;
  background-image: url(../assets/img-4/video-player/coursevideo_title.png);
  background-repeat: no-repeat;
}

a.vtn_wyks {
  background: #BB6054;
}

a.vtn_wyks > span {
  background-position: left 0;
}

a.vtn_wyks:hover > span {
  background-position: -50px 0;
}

a.vtn_jy {
  background: #4EBF92;
}

a.vtn_jy > span {
  background-position: left -50px;
}

a.vtn_jy:hover > span {
  background-position: -50px -50px;
}

a.vtn_xxmb {
  background: #C9A336;
}

a.vtn_xxmb > span {
  background-position: left -100px;
}

a.vtn_xxmb:hover > span {
  background-position: -50px -100px;
}

a.vtn_lsjj {
  background: #2292D4;
}

a.vtn_lsjj > span {
  background-position: left -150px;
}

a.vtn_lsjj:hover > span {
  background-position: -50px -150px;
}

.video_main {
  width: 100%;
  padding-top: 20px;
  background: #26262B;
}

.vm {
  position: relative;
  margin: 0 auto;
  padding-right: 320px;
}

/*右侧目录*/
.vm_list {
  position: absolute;
  top: 0;
  right: 0;
  width: 320px;
  background: #4C4C4D;
}

.vml_title {
  font-size: 18px;
  line-height: 50px;
  overflow: hidden;
  height: 50px;
  padding: 0 15px;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #C1C1C1;
}

.vml_main {
  overflow-y: auto;
  padding: 0 15px;
  padding-top: 10px;
}

.vml_main ul {
}

.vml_main ul li {
  position: relative;
  height: 60px;
  margin-bottom: 15px;
  padding-left: 114px;
  cursor: pointer;
}

.vml_main ul li span {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 104px;
  height: 60px;
  padding: 2px;
}

.vml_main ul li span p {
  font-size: 12px;
  line-height: 20px;
  position: absolute;
  right: 0;
  bottom: 0;
  width: 42px;
  height: 20px;
  text-align: center;
  white-space: nowrap;
  color: #FFFFFF;
  border-radius: 5px 0 0 0;
  background: rgba(0, 0, 0, 0.6);
}

.vml_main ul li a {
  font-size: 14px;
  line-height: 24px;
  display: block;
  overflow: hidden;
  height: 54px;
  padding-top: 6px;
  padding-right: 6px;
  color: #CCCCCC;
}

img.video_over {
  position: absolute;
  z-index: 9;
  top: -7px;
  left: 68px;
}

.vml_main ul li:hover {
  background: #616161;
}

.vml_main ul li.vmlm_ing {
  background: #616161;
}

.vml_main ul li.vmlm_ing span {
  background: #6CB517;
}

.vml_main ul li.vmlm_ing a {
  color: #6CB517;
}

.vml_main::-webkit-scrollbar {
  width: 8px;
}

.vml_main::-webkit-scrollbar-track {
  -moz-border-radius: 2em;
  -webkit-border-radius: 2em;
  border-radius: 2em;
  background-color: #888888;
}

.vml_main::-webkit-scrollbar-thumb {
  -moz-border-radius: 2em;
  -webkit-border-radius: 2em;
  border-radius: 2em;
  background-color: #DDDDDD;
}

.vm_star {
  position: relative;
  height: 46px;
  padding-right: 120px;
  padding-left: 260px;
}

.vm_star span.vms_title {
  font-size: 18px;
  line-height: 46px;
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100px;
  height: 46px;
  padding-left: 10px;
  color: #FFFFFF;
}

.vm_qingxi {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 120px;
  height: 20px;
}

.video_dabiao {
  font-size: 16px;
  font-weight: bold;
  line-height: 44px;
  width: 100%;
  text-align: center;
  color: #FF5207;
}

.vm_star .vms_pf {
  position: absolute;
  top: 13px;
  left: 100px;
}

/*根据浏览器宽度判断页面宽度*/
@media screen and (max-width: 1180px) {
  .vt {
    width: 980px;
  }
  
  .vm {
    width: 980px;
    height: 420px;
  }
  
  .vm_video {
    width: 100%;
    height: 371px;
  }
  
  .vml_main {
    height: 321px;
  }
  
  .video_comment {
    width: 980px;
  }
  
  .vt_nav a {
    margin-left: 10px;
  }
  
  .vt_nav {
    width: 761px;
  }
}

@media screen and (min-width: 1181px) and (max-width: 1680px) {
  .vt {
    width: 1180px;
  }
  
  .vm {
    width: 1180px;
    height: 531px;
  }
  
  .vm_video {
    width: 100%;
    height: 484px;
  }
  
  .vml_main {
    height: 434px;
  }
  
  .video_comment {
    width: 1180px;
  }
}

@media screen and (min-width: 1681px) {
  .vt {
    width: 1360px;
  }
  
  .vm {
    width: 1360px;
    height: 633px;
  }
  
  .vm_video {
    width: 100%;
    height: 585px;
  }
  
  .vml_main {
    height: 535px;
  }
  
  .video_comment {
    width: 1360px;
  }
}

.mt_main {
  position: relative;
  overflow: hidden;
  min-height: 185px;
}

.pl165 {
  padding-left: 165px;
}

.mtm_left {
  position: absolute;
  top: 0;
  left: 0;
  width: 150px;
  height: 185px;
}

.mtm_right {
}

.mtm_right p:nth-child(1) {
  font-size: 16px;
  line-height: 30px;
}

.mtm_right p:nth-child(2) {
  font-size: 14px;
  line-height: 22px;
}

</style>



// WEBPACK FOOTER //
// src/views/VideoPlayer.vue